// ----------------------------------------------------------------------------
// Copyright (c) Ben Coleman, 2020
// Licensed under the MIT License.
//
// Set of methods to call the Graph API, using REST and fetch
// ----------------------------------------------------------------------------

import auth from './auth_sharepoint'

const GRAPH_BASE = 'https://graph.microsoft.com/beta'
const GRAPH_SCOPES = [ 'user.read', 'user.readbasic.all','files.read.all','sites.read.all', ]

let accessToken

export default {
  //
  // Get details of user, and return as JSON
  // https://docs.microsoft.com/en-us/graph/api/user-get?view=graph-rest-1.0&tabs=http#response-1
  //
  async getSelf() {
    let resp = await callGraph('/me')
    if (resp) {
      let data = await resp.json()
      return data
    }
  },

  //
  // Get user's photo and return as a blob object URL
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  //
  async getPhoto() {
    //let resp = await callGraph('/me/photos/240x240/$value')
    let resp = await callGraph('/me')
    if (resp) {
      let blob = await resp.blob()
      return URL.createObjectURL(blob)
    }
  },

  //
  // Search for users
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  //
  async searchUsers(searchString, max = 50) {
    let resp = await callGraph(`/users?$filter=startswith(displayName, '${searchString}') or startswith(userPrincipalName, '${searchString}')&$top=${max}`)
    if (resp) {
      let data = await resp.json()
      return data
    }
  },

  async searchRepertoire(searchString) {
    let resp = await callGraph(`/sites/poupin.sharepoint.com,e66d47a6-7666-42a0-ad94-b34d04ce1e4f,9b77c3d7-0c51-4ba9-b9e3-11a860bbd15e/drive/root/search(q='${searchString}')`)
    if (resp) {
      let data = await resp.json()
      return data
    }
  },

  async searchRacine(searchString, max = 50) {
    let resp = await callGraph(`/users?$filter=startswith(displayName, '${searchString}') or startswith(userPrincipalName, '${searchString}')&$top=${max}`)
    if (resp) {
      let data = await resp.json()
      return data
    }
  },

  async getDocumentsChantier(searchString, graphClient){

    let resp = await callGraph(searchString)

    if (resp) {
      let data = await resp.json();
      let files = {};
      if(data.value.length > 0){
        await graphClient
            .api(`/sites/poupin.sharepoint.com,e66d47a6-7666-42a0-ad94-b34d04ce1e4f,9b77c3d7-0c51-4ba9-b9e3-11a860bbd15e/drive/items/${data.value[0].id}/children`)
            .get()
            .then( result => {
              files = result;
            })
      }

      return files;
    }
  },

  async goBackOneLevel(searchString, graphClient) {

    let resp = await callGraph(searchString)
    console.log(searchString)
    let files = {};
    if (resp) {
      await graphClient
          .api(searchString)
          .get()
          .then( result => {
            files = result;
          })
      console.log("graph_sharepoint.js : async gobackonelevel")
      console.log(files)
      return files;
    }
  },

  //
  // Accessor for access token, only included for demo purposes
  //
  getAccessToken() {
    return accessToken
  },

  async getRacine() {
    let resp = await callGraph('/sites/poupin.sharepoint.com,e66d47a6-7666-42a0-ad94-b34d04ce1e4f,9b77c3d7-0c51-4ba9-b9e3-11a860bbd15e/drive/root/children')
    if (resp) {
      let data = await resp.json()
      return data
    }
  },
}

//
// Common fetch wrapper (private)
//
async function callGraph(apiPath) {
  // Acquire an access token to call APIs (like Graph)
  // Safe to call repeatedly as MSAL caches tokens locally
  accessToken = await auth.acquireToken(GRAPH_SCOPES)

  let resp = await fetch(
      `${GRAPH_BASE}${apiPath}`,
      {
        headers: { authorization: `bearer ${accessToken}` }
      }
  )

  if (!resp.ok) {
    throw new Error(`Call to ${GRAPH_BASE}${apiPath} failed: ${resp.statusText}`)
  }


  return resp
}